import { LocationState } from './types'

export const state: LocationState = {
  currentLocation: null,
  editLocation: null,
  locations: null,
  previousLocation: null,
  defaultLocation: null
}
